module.exports = __webpack_public_path__ + "img/description1.adffe5a3.jpg";